import { Stack, Tooltip, Typography } from "@mui/material";
import CopyableTypography from "components/Typography/CopyableTypography";
import { FieldDisplay } from "routes/Staff/Fulfillment/FulfillmentDetails/shared/FieldComponents";

interface CredentialFieldsDisplayProps {
  credential:
    | {
        username?: string | null;
        password?: string | null;
        usesCombinedInvoicing?: boolean | null;
      }
    | null
    | undefined;
  portalUrl?: string | null;
  showCombinedInvoicing?: boolean;
}

export function CredentialFieldsDisplay({
  credential,
  portalUrl,
  showCombinedInvoicing = false,
}: CredentialFieldsDisplayProps) {
  return (
    <Stack spacing={1}>
      <FieldDisplay
        label="Username:"
        value={credential?.username ? <CopyableTypography text={credential.username} /> : "N/A"}
      />
      <FieldDisplay
        label="Password:"
        value={
          credential?.password ? (
            <Tooltip title="Click to copy" placement="top">
              <Typography
                variant="body1"
                onClick={() => navigator.clipboard.writeText(credential.password ?? "")}
                sx={{ cursor: "pointer", display: "inline-block" }}
              >
                ********
              </Typography>
            </Tooltip>
          ) : (
            "N/A"
          )
        }
      />
      <FieldDisplay
        label="URL:"
        value={
          portalUrl ? (
            <CopyableTypography
              text={portalUrl}
              sx={{
                display: "inline-block",
                maxWidth: "140px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            />
          ) : (
            "N/A"
          )
        }
      />
      {showCombinedInvoicing && (
        <FieldDisplay
          label="Uses Combined Invoicing:"
          value={credential?.usesCombinedInvoicing ? "Yes" : "No"}
        />
      )}
    </Stack>
  );
}
